import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	itemToolchain: {
		id: 'spa-apps-sidebar-next-gen.menu.settings.toolchain-menu-item.item-toolchain',
		defaultMessage: 'Toolchain',
		description: 'Toolchain overview link item.',
	},
});
